<script setup>
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";

const props = defineProps({
    property: Object,
    from: String | Number | null,
    to: String | Number | null,
    disabled: Boolean,
    error: String | undefined | null,
});
const emit = defineEmits(['update:from', 'update:to']);

</script>

<template>
    <div>
        <div class="px-2.5 py-1.25">
            <div class="flex justify-between gap-2.5">
                <InputLabel :class="{'text-red-500': !!error}" :value="property.title"
                            class="font-sans font-medium text-black dark:text-slate-200 flex items-center uppercase whitespace-nowrap"
                />
                <div class="flex gap-2.5">
                    <TextInput
                        :disabled="disabled"
                        :has-error="!!error"
                        :modelValue="from"
                        :placeholder="$t('From')"
                        class="w-1/2"
                        @update:modelValue="emit('update:from', $event)"
                    />
                    <TextInput
                        :disabled="disabled"
                        :has-error="!!error"
                        :modelValue="to"
                        :placeholder="$t('To')"
                        class="w-1/2"
                        @update:modelValue="emit('update:to', $event)"
                    />
                </div>

            </div>
            <div v-if="!!error" class="text-red-500 text-sm mt-1 pl-2">
                <ion-icon name="alert-circle" class="inline-block mr-1 align-middle"></ion-icon>
                <span class="text-sm align-middle">{{ error }}</span>
            </div>
        </div>
    </div>
</template>
